import axios from "../general/HttpClient";

export function CreateIdentityProvider(data) {
    return axios.post("/api/identityproviders", data).then((response) => {
        return response.data;
    });
}

export function DeleteIdentityProvider(id) {
    return axios.delete(`/api/IdentityProviders/${id}`).then((response) => {
        return response.data;
    });
}

export function UpdateIdentityProvider(idp) {
    return axios.put(`/api/IdentityProviders/${idp.id}`, idp).then((response) => {
        return response.data;
    });
}
